<template>
  <Wrapper
    v-show="
      !preview && renderTools && isShowWrapper &&
      !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)
    "
    id="grid-hover-frame"
    class="cursor-pointer"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    :position="gridHover.position"
    @click="click"
  >
    <!-- <GridHover class="lbl-name">
      <b-dropdown :dropup="!isOverScroll" :dropdown="isOverScroll">
        <template #button-content>
          Grid <i class="fas" :class="{'fa-caret-up': !isOverScroll, 'fa-caret-down': isOverScroll}"></i>
        </template>
      </b-dropdown>
    </GridHover> -->
    <GridHover class="lbl-name" style="left: 72px;" v-if="isOverlap && sectionActive.id == section_id">
      {{ $t('engine.floatframeTool.floatframeHover.grid.lblGrid', languageEngine) }}
    </GridHover>
    <GridHover class="lbl-name" v-else>
      {{ $t('engine.floatframeTool.floatframeHover.grid.lblGrid', languageEngine) }}
    </GridHover>
  </Wrapper>
</template>

<script>
import { GridHover, Wrapper } from "./GridHover.styled";
import { SECTION, WIDGET } from "@model/components/componentMeta.model";
import { findParentComponent } from "@helpers/component.helper";
// import Reheight from "./Reheight";

import { mapGetters } from "vuex";

export default {
  components: {
    GridHover,
    // Reheight,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  computed: {
    ...mapGetters({
      scrollPosition: "scrollPosition",
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetHover: "designIframe/frame/widgetHover",
      widgetActive: "designIframe/frame/widgetActive",
      sectionActive: "designIframe/frame/sectionActive",
      gridHover: "designIframe/frame/gridHover",
      gridActive: "designIframe/frame/gridActive",
      mode: "designIframe/mode",
      components: "designIframe/metadata/components",
      languageEngine: "designIframe/userPreference/languageEngine"
    }),
    gridMarginTop() {
      return (
        this.components[this.gridHover.id] &&
        this.components[this.gridHover.id].style.marginTop
      );
    },
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    section_id() {
      return this.gridHover.id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.gridHover.id)
      )[0][0];
    },
    sectionComponent() {
      return this.section_id && this.components[this.section_id]
    },
    sectionName() {
      return SECTION.name
    },
    widgetName() {
      return WIDGET.name
    },
    parentId() { // section or widget
      return this.gridHover.id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.gridHover.id)
      )[0][0];
    },
    parentComponent() { // section or widget
      return this.parentId && this.components[this.parentId]
    },
    parentName() {
      if (this.parentId) {
        if (this.parentId.substring(0, SECTION.prefixKey.length) == SECTION.prefixKey) {
          return this.sectionName
        } else if (this.parentId.substring(0, WIDGET.prefixKey.length) == WIDGET.prefixKey) {
          return this.widgetName
        }
      }
      return null;
    },
    parentFocusId() {
      if (this.parentId) {
        if (this.parentComponent.type == 'SECTION_WIDGET_TAB_ITEM') {
          return Object.entries(this.components).filter(
            (item) =>
              item[1].componentsID &&
              item[1].componentsID.includes(this.parentId)
          )[0][0];
        } else {
          return this.parentId
        }
      }
      return null;
    },
    indexGrid() {
      return this.sectionComponent.componentsID.indexOf(this.gridHover.id);
    },
    isFirstIndex() {
      return this.indexGrid == 0;
    },
    isOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isFirstIndex && this.gridMarginTop == 0
    },
    isParentWidget() {
      if (this.widgetActive.id) {
        const parentWidgetIds = findParentComponent(this.components, this.widgetActive.id);
        return parentWidgetIds.indexOf(this.gridHover.id) !== -1;
      }
      return false;
    },
    isShowWrapper() {
      return  this.gridHover.id && (this.gridHover.id != this.gridActive.id || this.isParentWidget)
    },
  },
  methods: {
    resetGridHoverPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.gridHover.id,
        type: "GRID",
        action: "HOVER",
      });
    },
    click() {
      if (this.gridHover.id) {
        const firstCellID = this.components[this.gridHover.id].componentsID[0];
        this.$store.dispatch("designIframe/frame/setWidgetActive", {})
        this.$store.dispatch("designIframe/frame/setWidgetHover", {})
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", firstCellID],
        });
        this.$store.dispatch("designIframe/frame/setCellActive", {
          component_id: firstCellID,
          parent_id: this.gridHover.id,
        });
      }
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: this.section_id,
        name: this.section_id,
      });
      this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
    },
  },
  watch: {
    scrollPosition() {
      this.$nextTick(function () {
        this.resetGridHoverPosition();
      });
    },
    mode() {
      this.$nextTick(function () {
        this.resetGridHoverPosition();
      });
    },
    gridMarginTop() {
      this.$nextTick(function () {
        this.resetGridHoverPosition();
      });
    },
    gridHover: {
      deep: true,
      handler() {
        const element = document.getElementById("grid-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
};
</script>

<style>
</style>